import React, { useCallback, useEffect, useState } from 'react'
import { Link, NavLink, useNavigate, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
  CButtonGroup,
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderDivider,
  CHeaderNav,
  CHeaderToggler,
  CButton,
  CDropdownItem,
  CDropdownMenu,
  CBadge,
  CDropdownToggle,
  CDropdown,
  CDropdownHeader,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import {
  cilBell,
  cilExternalLink,
  cilFlipToBack,
  cilInfo,
  cilMenu,
  cilUserFollow,
} from '@coreui/icons'

import { AppBreadcrumb } from './index'

import { AppHeaderDropdown } from './header/index'

import logo from '../assets/brand/logo.jpg'
import PageInfoModal from './PageInfoModal'
import CommonService from 'src/service/CommonService'
import ClaimPlayerProfileModal from './ClaimPlayerProfileModal'
import ToastComponent from './common/TaostComponent'
import ExternalModalBox from './ExternalModalBox'

const AppHeader = () => {
  const navigate = useNavigate()
  const [gameName, setGameName] = useState('')
  const [notificationCount, setNotificationCount] = useState(0)
  const [verifyPlayerList, setVerifyPlayerList] = useState([])
  const [paidRequest, setPaidRequest] = useState([])
  const [infoText, setInfoText] = useState('')
  const authenticated = localStorage.getItem('authenticated')
  const params = useParams()
  const uri = params['*']
  const fetchAppHeaderDetails = useCallback(() => {
    CommonService.getGameName(uri).then((res) => {
      if (res.success) {
        setGameName(res.game_name)
        setNotificationCount(res.notification_count)
        setVerifyPlayerList(res.verifyPlayerList)
        setPaidRequest(res.paymentRequest)
        setInfoText(res?.infoText)
      }
    })
  }, [uri, setGameName, setNotificationCount, setVerifyPlayerList, setInfoText])
  useEffect(() => {
    if (!authenticated) {
      navigate('/login')
    }
    fetchAppHeaderDetails()
  }, [navigate, authenticated, fetchAppHeaderDetails])

  const dispatch = useDispatch()
  const handleAccountPage = () => {
    navigate('/account')
  }
  const theme = useSelector((state) => state.theme)

  theme === 'dark'
    ? document.body.classList.add('dark-theme')
    : document.body.classList.remove('dark-theme')

  const sidebarShow = useSelector((state) => state.sidebarShow)
  const [infoPageModal, setInfoPageModal] = useState(false)
  const [externalPageModal, setExternalPageModal] = useState(false)

  // const pathName = window.location.pathname
  const handleInfoClick = () => {
    setInfoPageModal(true)
    CommonService.getHeaderInfoDetailsFromPathName(uri)
  }

  // Claim Player Profile modal open
  const [showClaimProfile, setShowClaimProfile] = useState(false)
  const handleCloseModal = (data) => {
    setShowClaimProfile(false)
  }
  // Claim Player Profile modal
  const adminDetails = JSON.parse(localStorage.getItem('admin'))
  const handlePaidRequest = (user_id, status) => {
    CommonService.markToPaidRequest(user_id, status).then((res) => {
      if (res.success) {
        ToastComponent(res.message, 'success')
        fetchAppHeaderDetails()
      }
    })
  }
  return (
    <>
      <CHeader position="sticky" className="mb-4">
        <CContainer fluid>
          <CHeaderToggler
            className="ps-1"
            onClick={() => dispatch({ type: 'set', sidebarShow: !sidebarShow })}
          >
            <CIcon icon={cilMenu} size="lg" />
            <span> {gameName ?? 'Cricket'}</span>
          </CHeaderToggler>

          <CHeaderBrand className="mx-auto d-md-none" to="/">
            <CIcon icon={logo} height={48} alt="Logo" />
          </CHeaderBrand>

          <CHeaderNav className="ms-auto me-4"></CHeaderNav>
          {adminDetails?.user_role_id !== 1 && (
            <CHeaderNav>
              <CHeaderNav className="ms-3 me-4">
                <CButton
                  type="button"
                  color="primary"
                  onClick={handleAccountPage}
                  title="Admin Account"
                  style={{ cursor: 'pointer' }}
                  size="sm"
                  // shape="rounded-pill"
                  variant="outline"
                  // className="ml-5"
                >
                  <CIcon icon={cilFlipToBack} size="sm" /> {'Home'}
                </CButton>
              </CHeaderNav>
              <CDropdown variant="nav-item" alignment="end">
                <CDropdownToggle caret={false}>
                  <CIcon icon={cilBell} size="lg" className="my-1 mx-2" />
                  <CBadge
                    shape="rounded-pill"
                    color="danger-gradient"
                    className="position-absolute top-0 end-0"
                  >
                    {notificationCount}
                  </CBadge>
                </CDropdownToggle>
                <CDropdownMenu className="pt-0">
                  <CDropdownHeader className="bg-light dark:bg-white dark:bg-opacity-10">
                    <strong>You have {notificationCount} notifications</strong>
                  </CDropdownHeader>
                  {verifyPlayerList &&
                    verifyPlayerList.map((item, key) => (
                      <CDropdownItem key={key}>
                        <Link onClick={() => setShowClaimProfile(true)}>
                          <CIcon icon={cilUserFollow} className="me-2 text-success" />
                          Player Verification Request: {item?.full_name}{' '}
                        </Link>
                      </CDropdownItem>
                    ))}
                  {paidRequest &&
                    paidRequest.map((item, key) => (
                      <CDropdownItem key={key}>
                        <CIcon icon={cilUserFollow} className="me-2 text-success" />
                        Paid request from {item?.full_name}. Click to{' '}
                        <Link onClick={() => handlePaidRequest(item?.user_id, 1)}>Approve</Link> or{' '}
                        <Link onClick={() => handlePaidRequest(item?.user_id, 2)}>Decline</Link>
                      </CDropdownItem>
                    ))}
                </CDropdownMenu>
              </CDropdown>
            </CHeaderNav>
          )}
          {adminDetails?.user_role_id === 1 && (
            <CHeaderNav className="ms-3 me-4">
              <AppHeaderDropdown />
            </CHeaderNav>
          )}
          <CHeaderNav className="ms-3 me-4">{/* <AppHeaderDropdown /> */}</CHeaderNav>
        </CContainer>

        <PageInfoModal
          infoPageModal={infoPageModal}
          setInfoPageModal={setInfoPageModal}
          infoText={infoText}
        />
        <ExternalModalBox
          externalPageModal={externalPageModal}
          setExternalPageModal={setExternalPageModal}
        />
      </CHeader>
      <ClaimPlayerProfileModal
        showClaimProfile={showClaimProfile}
        setShowClaimProfile={setShowClaimProfile}
        onCloseModal={handleCloseModal}
        verifyPlayerList={verifyPlayerList}
        fetchAppHeaderDetails={fetchAppHeaderDetails}
      />
    </>
  )
}

export default AppHeader
